import semver from "semver";

import useFeatureFlag from "../main/graphql/hooks/useFeatureFlag";
import useCurrentUser from "../main/hooks/useCurrentUser";

const featureVersionMap = {
  // eslint-disable-next-line camelcase
  paste_scorecard: "2.2.10",
  "one-click-scorecard": "2.2.24",
  "scorecard-format-07-2024": "2.5.1",
  "autofill-scorecard:v3": "3.10.0",
};

type ExtensionFeature = keyof typeof featureVersionMap;

/**
 * Whether the current user has the appropriate browser extension version
 * installed for the given feature. Can optionally check a for a feature flag
 * as well.
 */
function useBrowserExtensionFeatureEnabled(
  extensionFeatureName: ExtensionFeature,
  options?: { checkFeatureFlag?: boolean }
): boolean {
  const featureFlagEnabled = useFeatureFlag(extensionFeatureName);
  const { browserExtensionVersion } = useCurrentUser();
  if (!browserExtensionVersion) {
    return false;
  }
  const hasRelevantVersion = semver.gte(
    browserExtensionVersion,
    featureVersionMap[extensionFeatureName]
  );

  if (!hasRelevantVersion) {
    return false;
  }

  if (options?.checkFeatureFlag) {
    return featureFlagEnabled;
  }

  return true;
}

export default useBrowserExtensionFeatureEnabled;
